import { ActionEnum } from '../enum/action.enum';
import { ActionFunction } from '../interface/action/action-function.type';
import { ImageModel } from '../model/media-library/image.model';
import { action } from 'mobx';

export interface IMediaLibraryOpenPayload {
  insertFunction: (image: ImageModel) => void;
}

const mediaLibraryOpen$: ActionFunction<IMediaLibraryOpenPayload> = (action$, {state}) => {
  return action$
    .type(ActionEnum.MEDIA_LIBRARY_OPEN)
    .end(action((payload: IMediaLibraryOpenPayload) => {
      state.mediaLibrary.onInsert(payload.insertFunction);
      return state.mediaLibrary.isOpen = true;
    }));
};

const mediaLibraryClose$: ActionFunction = (action$, {state}) => {
  return action$
    .type(ActionEnum.MEDIA_LIBRARY_CLOSE)
    .end(action(() => {
      (state.mediaLibrary as any).insertSignal.removeAll();
      return state.mediaLibrary.isOpen = false;
    }));
};

export default {
  actions: [
    mediaLibraryOpen$,
    mediaLibraryClose$
  ]
};
